import { fetchJson } from "../lib/fetchJson.js";

interface ShopifyCartItem {
  variant_id: string
  quantity: number
}
class FFCartLink {
  link = ""
  DOM: {
    modal: HTMLDialogElement | null
    trigger: HTMLElement | null
    copyInput: HTMLInputElement | null
    copyButton: HTMLElement | null
  }

	constructor () {
		this.DOM = {
      modal: document.querySelector(".js-shareCartModal"),
			trigger: document.querySelector(".ffjs-cartLinkTrigger"),
			copyInput: document.querySelector(".ffjs-cartLinkCopyInput"),
			copyButton: document.querySelector(".ffjs-cartLinkCopyButton"),
		}
		this.events()
	}

	events(){
    this.DOM.modal?.addEventListener("click", this.dialogClick.bind(this))
		this.DOM.trigger?.addEventListener("click", this.openModal.bind(this))
		this.DOM.copyButton?.addEventListener("click", this.copyLink.bind(this))
	}

  dialogClick(e: MouseEvent){
		if( !this.DOM.modal ) return
    const rect = this.DOM.modal.getBoundingClientRect();
    const isInDialog = (rect.top <= e.clientY && e.clientY <= rect.top + rect.height &&
      rect.left <= e.clientX && e.clientX <= rect.left + rect.width);
    if (!isInDialog) {
      this.DOM.modal.close();
    }
  }

	async openModal(){
		this.DOM.trigger?.classList.add("working")
		try {
			const cart = await this.getCart()
			const data = cart.items
        .map( el => ({
          id: el.variant_id,
          quantity: el.quantity,
        }))
			const links = await this.getLinks(data)
			this.link = links.shortLink
      if( this.DOM.copyInput instanceof HTMLInputElement ){
        this.DOM.copyInput.value = links.shortLink
      }
			this.DOM.trigger?.classList.remove("working")
			this.DOM.modal?.showModal()
		} catch (_error) {
			this.DOM.trigger?.classList.remove("working")
		}
	}

	async getCart (): Promise<{ items: ShopifyCartItem[] }>{
		return fetchJson("/cart.js")
	}

	async getLinks( data: { id: string, quantity: number }[] ): Promise<{ shortLink: string }>{
		return fetchJson("https://jxfh5kh7sk.execute-api.us-west-2.amazonaws.com/Prod/shorten", {
			method: "POST",
			headers: { 'Content-Type': 'application/json', },
			body: JSON.stringify(data),
		})
	}

	copyLink(){
    navigator.clipboard.writeText(this.link)
	}
}
new FFCartLink()